import React, { ReactElement, ReactNode } from 'react';
import Icon from '@components/Icon';
import clsx from 'clsx';

interface WarningBoxProps {
  level: 'info' | 'warning' | 'danger';
  children: ReactNode;
  className?: string;
}

const WarningBox = ({
  level,
  children,
  className,
}: WarningBoxProps): ReactElement => {
  return (
    <div
      className={clsx(
        'rounded-medium border px-3 py-2 flex',
        {
          'text-lightGray border-lightGray': level === 'info',
          'text-orange border-orange': level === 'warning',
          'text-red border-red': level === 'danger',
        },
        className
      )}
      data-testid={`warning-box-${level}-level`}
    >
      <div className="w-[20px]">
        <Icon.Warning className="text-iconSmall mt-[2px]" />
      </div>
      <div className="ml-[10px] text-smallRegular text-left">{children}</div>
    </div>
  );
};

export default WarningBox;
